var map = {
	"./1-on.png": "f049",
	"./11-on.png": "067b",
	"./12-on.png": "53c0",
	"./3-on.png": "6af0",
	"./5-on.png": "1612",
	"./6-on.png": "d36c",
	"./7-on.png": "4e5e",
	"./8-on.png": "04d3",
	"./9-on.png": "4c42"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f2f6";